// @ts-nocheck 25a623ca
import * as addPanel from '#packages/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.sections.getSections().hoverBox;
  },
};
